import { ConfirmDialogContext } from 'components/common/GlobalConfirmDialog/GlobalConfirmDialogProvider';
import { useContext } from 'react';

const useConfirm = () => {
  const { open, close, isOpen } = useContext(ConfirmDialogContext);
  return { open, close, isOpen };
};

export default useConfirm;
